module.exports = __webpack_public_path__ + "static/img/home-banner1x.c17dc5e1.png";